<template>
    <div>
        <div class="departmentBox">
            <avue-crud :data="data" :option="option" :page.sync="page" @current-change="changePage">
                <template slot="menuLeft" slot-scope="{size}">
                    <el-button  :size="size" class="View">新建印章</el-button>
                </template>
                <template slot-scope="scope" slot="menu">
                    <el-button  class="View">授权</el-button>
                    <el-button  class="View">查看授权</el-button>
                    <el-button  class="View">删除</el-button>
                </template>
            </avue-crud>
        </div>
    </div>
</template>

<script>
    export default {
        name: "sealManagement",
        data() {
            return {
                page: {
                    currentPage: 1,
                    total: 60,  //总数
                    pageSize: 10, //每页多少
                    // pagerCount:5
                },
                data: [
                    {
                        seal:'http://pic.soutu123.com/back_pic/18/07/06/514e96eedb99a663e02ab32614713243.jpg!/fw/700/quality/90/unsharp/true/compress/true',
                        name:'公章',
                        number:'131316313',
                        type:'公章'

                    }, {
                        seal:'http://pic.soutu123.com/back_pic/18/07/06/514e96eedb99a663e02ab32614713243.jpg!/fw/700/quality/90/unsharp/true/compress/true',
                        name:'合同专用章',
                        number:'131316313',
                        type:'合同专用章'
                    }
                ],
                option:{
                    addBtn:false,
                    stripe:true,
                    menuWidth: 280, //操作菜单栏的宽度
                    align:'center',  // 表格列齐方式
                    menuAlign:'center', // 菜单栏对齐方式
                    columnBtn:false, //列动态显隐按钮
                    refreshBtn:false, // 刷新按钮
                    delBtn:false, // 行内删除按钮
                    editBtn:false, // 行内编辑按钮
                    column:[
                        {
                          label: '印章',
                          prop: 'seal',
                          type:'upload',
                          listType:'picture-card',
                        }, {
                            label:'印章名称',
                            prop:'name',

                        }, {
                            label: '印章编号',
                            prop: 'number'
                        }, {
                            label: '印章类型',
                            prop: 'type'
                        }

                    ]
                },
            };
        },
        methods:{
            changePage(num){
                console.log(num)
            }
        }
    }
</script>

<style scoped>
    .departmentBox{
        padding: 30px;
        margin: 10px;
        background-color: #fff;
        border-radius: 5px;
    }
    .View{
        background-color: #3b63f6;
        color: #fff;
    }
    /deep/.el-card__body{
        text-align: center;
    }
</style>
